angular.module('impactx.list').directive('ixPaginationServer', function (PaginationService, $rootScope) {
    return {
        restrict: 'E',
        require: '^^stTable',
        templateUrl: 'shared/list/templates/serverside/pagination.server.tmpl.html',
        link: function (scope) {
            scope.$watch(function () {
                    return PaginationService.rowCount;
                },
                function (newValue) {
                    scope.rowCount = newValue;
                });

            $rootScope.$on('paginationSelectPage', function (event, paginationData) {
                if (paginationData.lastPageIndex <= paginationData.selectedPage) {
                    scope.$applyAsync(function () {
                        applySelectedPageChanges(paginationData.selectedPage)
                    });
                }
                else {
                    applySelectedPageChanges(paginationData.selectedPage)
                }
            });

            function applySelectedPageChanges(selectedPage) {
                scope.currentPage = selectedPage > 0 ? selectedPage : 1;
                scope.numPages = selectedPage + 1;
                scope.selectPage(selectedPage);
            }
        }
    }
});